import { KYC_LEVELS } from "@jagad/constants"
import KYCLevelNumber from "../KYCLevelNumber/KYCLevelNumber"
import { Container, LevelName } from "./KYCAccountBadge.styles"

export type KYCAccountBadgeProps = {
    level: number
    bold?: boolean
}

const KYCAccountBadge = ({
    level,
    bold = true
}: KYCAccountBadgeProps) => {
    return (
        <Container>
            <KYCLevelNumber number={level} size={24} />
            <LevelName $bold={bold}>
                {KYC_LEVELS[level].name}
            </LevelName>
        </Container>
    )
}

export default KYCAccountBadge
